<template>
  <div class="project-list-items">
    <div class="window-container">
      <div class="page-container">
        <v-expansion-panels
          v-for="(project, index) in projects"
          :key="index"
          accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-checkbox
                v-if="remoteList && !hideCheckboxes"
                v-model="localSelectedProjects"
                :value="project.uuid"
                loading
                hide-details
                @click.stop="handleCheckbox(project.uuid)"
              />
              <v-layout justify-space-between>
                <v-flex
                  sm4
                  wrap
                  @click="onNameClick(project.uuid)"
                >
                  <h3 class="text-uppercase">
                    {{ patientName(project.patient_uuid) }}
                  </h3>
                  <span
                    v-if="showApplicator"
                    class="ml-3"
                  >Applicateur:
                    {{ applicatorName(project.applicator_id) }}</span>
                </v-flex>

                <v-flex
                  d-flex
                  sm4
                  align-center
                  justify-center
                >
                  <h3 class="text-uppercase getProductName">
                    {{ getProductName(project.product_model) }}
                  </h3>
                </v-flex>

                <v-flex
                  d-flex
                  sm4
                  align-center
                  justify-end
                >
                  <p class="date">
                    {{ project.created_at | dateFormat }}
                  </p>
                  <v-icon
                    v-if="
                      showSync &&
                        (project.local_version || project.updated) &&
                        project.transferable &&
                        isOnline
                    "
                    class="mr-2"
                    @click.stop="onSync(project)"
                  >
                    mdi-sync
                  </v-icon>
                  <span
                    v-if="project.transferable && isOnline"
                    class="mr-5"
                  >Transferable</span>
                  <span
                    v-else-if="!isOnline"
                    class="mr-5"
                  >En attente de connexion</span>
                  <v-icon
                    v-if="project.product_uuid == ''"
                    class="mr-2"
                    small
                  >
                    mdi-alert
                  </v-icon>
                  <img
                    v-if="!project.idc_locked"
                    src="@/assets/img/icons/lock-icon.svg"
                    alt
                  >
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>Lieu: {{ patientAddress(project.patient_uuid) }}</p>
              <p>Tel: {{ patientPhone(project.patient_uuid) }}</p>
              <p>Centre: {{ project.center }}</p>
              <!-- <p > -->
              <v-btn
                v-if="showDelete && project.initial_transfer_at == ''"
                small
                outlined
                color="warning"
                @click="deleteProject(project)"
              >
                <v-icon left>
                  mdi-delete
                </v-icon>Supprimer
              </v-btn>
              <!-- </p> -->
              <p
                v-if="project.molding_arrival_at != null && userRole == 'CHIEF'"
              >
                Date de moulage: {{ project.molding_arrival_at }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { products } from "@/mixins/products";

export default {
  name: "ProjectListItems",
  mixins: [products],
  props: {
    projects: {
      type: Array,
      required: true
    },

    selectedProjects: {
      type: Array,
      default: () => []
    },

    remoteList: {
      type: Boolean,
      default: false
    },

    showApplicator: {
      type: Boolean,
      default: false
    },

    showSync: {
      type: Boolean,
      default: false
    },

    showDelete: {
      type: Boolean,
      default: false
    },

    hideCheckboxes: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Patients
      patients: [],
      users: [],

      localSelectedProjects: []
    };
  },
  computed: {
    ...mapGetters({
      userRole: "auth/getLoggedInUserRole"
    })
  },

  async mounted() {
    this.localSelectedProjects = this.selectedProjects;
    this.patients = await this.getLocalPatients();
    this.users = await this.getLocalUsers();
  },

  methods: {
    ...mapActions({
      getLocalPatients: "patients/getLocalPatients",
      getLocalUsers: "users/getLocalUsers"
    }),

    deleteProject(project) {
      this.$emit("delete-project", project);
    },

    // Return patient name
    patientName(patient_uuid) {
      const patient = this.patients.find(
        patient => patient.uuid === patient_uuid
      );

      if (!patient) {
        return "";
      }

      return patient.lastname + " " + patient.firstname;
    },

    // Return applicator name
    applicatorName(applicator_id) {
      const applicator = this.users.find(
        applicator => applicator.id === applicator_id
      );

      if (!applicator) {
        return "";
      }

      const name = applicator.lastname + " " + applicator.firstname;

      return name.toUpperCase();
    },

    // Return patient address
    patientAddress(patient_uuid) {
      const patient = this.patients.find(
        patient => patient.uuid === patient_uuid
      );

      if (!patient) {
        return "";
      }

      if (!patient.address || !patient.zipcode || !patient.city) {
        return "Non renseigné";
      }

      return `${patient.address} ${patient.zipcode} ${patient.city}`;
    },

    // Return patient phone
    patientPhone(patient_uuid) {
      const patient = this.patients.find(
        patient => patient.uuid === patient_uuid
      );

      if (!patient) {
        return "";
      }

      if (!patient.phone) {
        return "Non renseigné";
      }

      const phone = patient.phone;
      const chunks = phone.match(/.{1,2}/g); // Create chunks of 2 characters
      return chunks.join(" ");
    },

    // Emit name-click on name click
    onNameClick(project_uuid) {
      this.$emit("name-click", project_uuid);
    },

    // Emit name-click on name click
    onSync(project) {
      this.$emit("sync", project);
    },

    handleCheckbox(value) {
      const index = this.localSelectedProjects.indexOf(value);
      if (index === -1) {
        this.localSelectedProjects.push(value);
      } else {
        this.localSelectedProjects.splice(index, 1);
      }
    }
  }
};
</script>

<style lang="scss">
.project-list-items {
  .v-input--selection-controls {
    margin: 0;
    padding: 0;
    &.v-input {
      flex-grow: 0 !important;
    }
  }
  .getProductName {
    color: #880e4f;
  }
  p {
    color: #880e4f;
    margin: 0;
    margin-bottom: 5px !important;
    font-size: 10px !important;
  }
  .v-expansion-panel {
    border-top: 1px solid rgba(#9f9f9f, 0.2);
    border-bottom: 1px solid rgba(#9f9f9f, 0.2);
    border-radius: 0;
    &::before {
      box-shadow: none;
    }
    .v-expansion-panel-header {
      padding: 7px 24px;
      min-height: 50px;
      .date {
        margin: 0 !important;
        margin-right: 20px !important;
      }
    }
  }
  .window-container {
    height: calc(100vh - 56px - 60px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 55px 45px;
    .page-container {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
  }
  h3 {
    border: none !important;
  }
}
</style>
